'use client';

import Script from 'next/script';

import { setGoogleSignInScriptReady } from './google-sign-in';

export const GoogleSignInScript = () => (
  <Script id='google-auth-script' src='https://accounts.google.com/gsi/client' onReady={setGoogleSignInScriptReady} />
);
